import { getPinnedViewsQuickFetch } from 'customer-data-views-management/pinnedViews/api/getPinnedViews';
import { quickFetchDefaultPinnedView } from 'customer-data-views-management/quickFetch/defaultPinnedViewQuickFetch';

/**
 * Initiates early requests to fetch view data for a given object type.
 * Triggers a fire-and-forget request for all pinned views and returns a promise for the default pinned view.
 *
 * @param params - Configuration parameters for fetching views
 * @param params.objectTypeId - The ID of the object type to fetch views for
 * @param params.viewId - Optional specific view ID to fetch
 * @param params.namespace - The namespace for the views (defaults to 'NONE')
 * @param params.defaultViewIds - @deprecated This parameter is no longer used and will be removed in a future version
 * @returns An object containing the default pinned view promise
 */
export function quickFetchViews({
  namespace = 'NONE',
  objectTypeId,
  viewId
}) {
  const defaultPinnedViewPromise = quickFetchDefaultPinnedView({
    objectTypeId,
    namespace,
    viewId
  });
  getPinnedViewsQuickFetch({
    objectTypeId,
    namespace
  });
  return {
    defaultPinnedViewPromise
  };
}